/** A header with a trailing reveal link, over a bound list of `card` rows. */
import { useState } from 'react';
import { Surface, Vertical } from './primitives';
import { PanelHeader } from './panelHeader';
import { ItemCollection } from './collections';

export function WishlistShelf({ nodeId, node, props = {}, data, ctx, emit, slots, renderTemplate }) {
  const cap = Number(props.limit) > 0 ? Number(props.limit) : 0;
  const [open, setOpen] = useState(false);
  const action = props.action || null;

  const reveal = () => {
    setOpen((v) => !v);
    emit?.('actionActivated', { action: action?.action || action?.label || null });
  };

  return (
    <Surface variant="card" props={{ padding: '4', radius: 28 }}>
      <Vertical props={{ gap: '3' }}>
        <PanelHeader title={props.title} action={action} onAction={reveal} />
        <ItemCollection
          nodeId={nodeId}
          node={node}
          props={{
            layout: 'list',
            // A wishlist is a LIST of rows: the hairline is what separates one
            // saved thing from the next, not a gutter.
            divided: true,
            // The shelf opens on a GLANCE — the reveal link is what turns the
            // glance into the whole list, so the cap lives here, not on the caller.
            limit: open ? 0 : cap,
            items: props.items,
            card: props.card,
            emptyTitle: props.emptyTitle,
            emptyBody: props.emptyBody,
          }}
          data={data}
          ctx={ctx}
          emit={emit}
          slots={slots}
          renderTemplate={renderTemplate || props.renderTemplate}
        />
      </Vertical>
    </Surface>
  );
}

export default WishlistShelf;
